import { StyleSheet } from 'aphrodite';
import { brandPrimary, brandSecondary, error, grayIconFill, midGray } from '../../styles/colors';
import { CssSelectors } from '../../styles/styles';

export const styleSheet = StyleSheet.create({
	body: {
		overflow: 'auto',
		height: 500,
		paddingRight: 16,
	},
	bodyText: {
		color: '#4A4A4A',
		marginBottom: 20,
	},
	buttonsContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		paddingTop: 20,
	},
	container: {
		height: 600,
		maxWidth: 400,
	},
	deleteCta: {},
	inputWrapper: {
		paddingBottom: 10,
	},
	isDisabledContainer: {
		display: 'flex',
		flexDirection: 'row',
		...CssSelectors.allChildren(
			{
				marginLeft: 75,
			},
			':not(:first-child)'
		),
	},
	label: {
		color: grayIconFill,
	},
	leftButtonGroup: {
		display: 'flex',
		flexDirection: 'row',
		...CssSelectors.allChildren(
			{
				marginLeft: 20,
			},
			':not(:first-child)'
		),
	},
	modal: {
		...CssSelectors.allChildren(
			{
				'@media only screen and (max-height: 768px)': {
					alignItems: 'flex-start',
				},
				alignItems: 'center',
			},
			'.modal-overlay'
		),
	},
	text: {
		fontSize: 14,
		lineHeight: '18px',
	},
	title: {
		color: brandSecondary,
		fontSize: 18,
		lineHeight: '22px',
		marginBottom: 16,
	},
	tooltip: {
		marginLeft: 6,
	},
	inlineTooltip: {
		marginLeft: 4,
		display: 'inline-flex',
		alignItems: 'center',
	},
	tooltipContent: {
		display: 'block',
		overflowWrap: 'break-word',
		whiteSpace: 'normal',
		width: 350,
	},
	infoText: {
		color: brandPrimary,
		fontSize: 14,
		marginTop: 8,
		fontStyle: 'italic',
	},
	radioButtonGroup: {
		display: 'flex',
		alignItems: 'center',
	},
	aiRadioButton: {
		marginLeft: 24,
	},
	disabledText: {
		opacity: 0.5,
		cursor: 'not-allowed',
		color: midGray,
	},
	aiOptionWrapper: {
		display: 'flex',
		alignItems: 'center',
		marginLeft: 24,
	},
	tooltipWrapper: {
		marginLeft: 5,
		display: 'flex',
		alignItems: 'center',
		position: 'relative',
		top: 1,
	},
	smallQuestionIcon: {
		transform: 'scale(0.8)',
	},
	spacer: {
		marginTop: 20,
		marginBottom: 5,
	},
	inlineCheckboxContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		marginBottom: 4,
	},
	customInstructionsTextArea: {
		minHeight: 200,
		resize: 'vertical',
	},
	customInstructionsFooter: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		gap: 12,
		marginTop: 6,
	},
	customInstructionsHelper: {
		color: grayIconFill,
		fontSize: 12,
		lineHeight: '16px',
		flex: 1,
	},
	customInstructionsCounter: {
		color: grayIconFill,
		fontSize: 12,
		lineHeight: '16px',
		flexShrink: 0,
		minWidth: 70,
		textAlign: 'right',
		fontVariantNumeric: 'tabular-nums',
	},
	customInstructionsCounterOver: {
		color: error,
	},
});
